/**
 * Dove porta una notifica, quando porta da qualche parte (465): l'esportazione pronta alla pagina da
 * cui si scarica, il ricontatto alla scheda della persona, il secondo fattore azzerato (493) alla
 * pagina dove se ne attiva uno nuovo. Una richiesta da decidere porta alle approvazioni; l'avviso
 * sulla propria casella (supervisione, lettura) alla Posta, dove si leggono chi legge e perche';
 * l'invito a scrivere una bozza (505) alla bozza stessa.
 *
 * Sta qui e non nella pagina delle notifiche perche' la usa anche il riquadro degli avvisi sullo
 * schermo (componenti/AvvisiSchermo.tsx, 2/11/2026). Senza React: le regole degli avvisi la provano
 * fuori dal browser.
 */
export function collegamentoNotifica(n: {
  oggetto_tipo: string | null; oggetto_id?: string | null; persona_id: string | null
}): { a: string; testo: string } | null {
  if (n.oggetto_tipo === 'export') return { a: '/esportazioni', testo: 'Vai alle tue esportazioni' }
  if (n.oggetto_tipo === 'secondo_fattore') return { a: '/secondo-fattore', testo: 'Vai a «Secondo fattore»' }
  if (n.oggetto_tipo === 'approvazione') return { a: '/approvazioni', testo: 'Vai alle approvazioni' }
  // La casella dell'avviso, non quella personale o l'ultima scelta: «Posta nuova in amministrazione@» apriva
  // la propria casella e l'email non si trovava (2/11/2026).
  if (n.oggetto_tipo === 'casella') {
    return { a: n.oggetto_id ? `/posta?casella=${encodeURIComponent(n.oggetto_id)}` : '/posta', testo: 'Vai a «Posta»' }
  }
  // Posta nuova che una regola di smistamento (540) ha spostato: <casella>/<cartella>, la Posta apre quella cartella.
  if (n.oggetto_tipo === 'cartella_posta' && n.oggetto_id) {
    const [casella, cartella] = n.oggetto_id.split('/')
    const q = new URLSearchParams({ casella: casella ?? '', ...(cartella ? { cartella } : {}) })
    return { a: `/posta?${q.toString()}`, testo: 'Vai alla cartella' }
  }
  // Invito a scrivere una bozza (505): la Posta la apre subito.
  if (n.oggetto_tipo === 'bozza' && n.oggetto_id) {
    return { a: `/posta?bozza=${encodeURIComponent(n.oggetto_id)}`, testo: 'Apri la bozza' }
  }
  // Regola di cancellazione della posta (500): l'avviso di preavviso e il cambio della regola.
  if (n.oggetto_tipo === 'posta_cancellazione' || n.oggetto_tipo === 'regola_posta') {
    return { a: '/posta?linguetta=cancellazione', testo: 'Vai a «In cancellazione»' }
  }
  if (n.oggetto_tipo === 'follow_up' && n.persona_id) return { a: `/persone/${n.persona_id}`, testo: 'Apri la scheda' }
  // Messaggio diretto nel messenger (530): la pagina «Messenger»; la chat la apre Element.
  if (n.oggetto_tipo === 'messenger') return { a: '/messaggi', testo: 'Apri il messenger' }
  // Sede chiusa in un giorno con impegni (556): l'agenda di quel giorno (decisione di Davide del 3/11/2026).
  // L'oggetto e' <chiusura>/<giorno del primo impegno di chi riceve l'avviso>/<sede di quell'impegno>; senza
  // sede (gli avvisi di prima, la mediazione fuori sede) l'agenda di partenza.
  if (n.oggetto_tipo === 'sede_chiusura' && n.oggetto_id) {
    const [, giorno, sede] = n.oggetto_id.split('/')
    if (giorno && /^\d{4}-\d{2}-\d{2}$/.test(giorno)) {
      const q = new URLSearchParams({ ...(sede && /^[0-9a-f-]{36}$/.test(sede) ? { sede } : {}), vista: 'giorno', giorno })
      return { a: `/agenda?${q.toString()}`, testo: 'Apri l’agenda del giorno' }
    }
  }
  // Turno o invito dell'agenda (559): la propria agenda nel giorno. L'oggetto e' <impegno>/<giorno>.
  if (n.oggetto_tipo === 'agenda_evento' && n.oggetto_id) {
    const [, giorno] = n.oggetto_id.split('/')
    if (giorno && /^\d{4}-\d{2}-\d{2}$/.test(giorno)) {
      return { a: `/agenda?sede=mia&vista=giorno&giorno=${giorno}`, testo: 'Apri la tua agenda' }
    }
  }
  // Promemoria degli impegni del giorno dopo (562): l'oggetto e' il giorno. «La mia agenda», oppure «Il mio
  // calendario» a chi ha solo le proprie mediazioni (il mediatore).
  if ((n.oggetto_tipo === 'agenda_giorno' || n.oggetto_tipo === 'mediazioni_giorno') && n.oggetto_id
      && /^\d{4}-\d{2}-\d{2}$/.test(n.oggetto_id)) {
    return n.oggetto_tipo === 'agenda_giorno'
      ? { a: `/agenda?sede=mia&vista=giorno&giorno=${n.oggetto_id}`, testo: 'Apri la tua agenda' }
      : { a: `/mediazioni/mio-calendario?vista=giorno&giorno=${n.oggetto_id}`, testo: 'Apri il tuo calendario' }
  }
  // Quarantena degli allegati (546): recupero chiesto, pronto o scaricato.
  if (n.oggetto_tipo === 'posta_quarantena') return { a: '/posta?linguetta=quarantena', testo: 'Vai a «Quarantena»' }
  return null
}
